/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ReactNode, useCallback } from 'react';
import { Alert, SvgIcon } from '@mui/material';
import { SnackbarContent } from 'notistack';
import IStoreState from 'store/IStoreState';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorOutline, WarningAmber } from '@mui/icons-material';
import { ReactComponent as CheckGreen } from 'assets/checkGreen.svg';
import { NotificationKey } from '../stateManagement/state';
import { popupNotificationClosed } from '../stateManagement/actionsCreator';

const PopupNotification = React.forwardRef<
  HTMLDivElement,
  {
    id: NotificationKey;
    message: string | ReactNode;
  }
>(({ id, message }, ref) => {
  const dispatch = useDispatch();
  const severity = useSelector(
    (store: IStoreState) =>
      store.popupNotifications.find((n) => n.key === id)?.notification
        .severity ?? 'info'
  );

  const handleDismiss = useCallback(() => {
    dispatch(popupNotificationClosed(id));
  }, [id, dispatch]);

  return (
    <SnackbarContent ref={ref}>
      <Alert
        id={`${severity}-notification`}
        onClose={handleDismiss}
        severity={severity === 'neutral' ? 'info' : severity}
        sx={{
          width: {
            xs: 400,
            lg: 450,
          },
          background:
            severity === 'neutral'
              ? (t) => t?.palette?.neutral?.dark
              : undefined,
        }}
        iconMapping={{
          success: (
            <SvgIcon
              viewBox='0 0 18 18'
              sx={{ width: 18, height: 18, alignSelf: 'center' }}
              component={CheckGreen}
            />
          ),
          error: <ErrorOutline color='error' />,
          warning: <WarningAmber color='warning' />,
        }}
        data-testid='popup-notification'
        aria-live='assertive'
      >
        {message}
      </Alert>
    </SnackbarContent>
  );
});

PopupNotification.displayName = 'PopupNotification';
export default PopupNotification;
